import axios from 'axios';

export default {
    pre_insercion(p_email, p_usuario) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_valindemniza.pre_insercion",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
				  })
			})
	},
    
    recuperar(p_email, p_usuario, p_fecpago) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_valindemniza.recuperar",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_fecpago": p_fecpago
				  })
			})
	},

	recuperar_detalle(p_email, p_usuario, p_siniestro) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_valindemniza.recuperar_detalle",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_siniestro": p_siniestro
				  })
			})
	},

	autorizar(p_email, p_usuario, p_siniestro) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_valindemniza.marcarvb",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_siniestro": p_siniestro
				  })
			})
	},

	rechazar(p_email, p_usuario, p_siniestro, p_observacion) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_valindemniza.rechazarvb",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_siniestro": p_siniestro,
					"p_observacion": p_observacion
				  })
			})
	},
}